import React from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import AssistantChat from "../../components/Chats/AssistantChat";
import {ImeanHeader} from "../../components/Header/Header";
import {StickyNavigationHeader} from "../../components/Navigation/StickyNavigationHeader";


const AssistantPage = () => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	return (
			<div className='min-h-96 h-[calc(100dvh-250px)]'>
				<ImeanHeader initialDark={true}></ImeanHeader>
				<StickyNavigationHeader headerTitle={t("assistant.header")} onBackClick={() => navigate('/home')}></StickyNavigationHeader>
				<AssistantChat/>

			</div>
	);
};

export default AssistantPage;